import React from 'react'
import useSections from '@page-components/CheckoutV3/hooks/useSections'

import Money from './Money'

export default function Summary() {
  const sections = useSections()
  if (!sections.includes('summary')) return null

  return (
    <div className="p-4">
      <Money />
    </div>
  )
}
